import React, { Component, Fragment } from 'react';
import SwipeableViews from 'react-swipeable-views';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import { AccentColor } from 'helpers/AccentColorHelper';

import { muiThemeNext } from 'helpers/MUIFiles';
import { MuiThemeProvider } from '@material-ui/core';

function TabContainer({ children, dir }) {
  return (
    <Typography component="div" dir={dir} style={{ fontSize: '14px', height: '100%' }}>
      {children}
    </Typography>
  );
}

const styles = theme => ({
  tabsRoot: {
    minHeight: '40px',
  },
  tabsIndicator: {
    backgroundColor: AccentColor(),
  },
  tabRoot: {
    fontSize: '13px',
    padding: 0,
    minWidth: '45px',
    color: 'rgb(78, 78, 78)',

    '&:hover': {
      color: AccentColor(),
      opacity: 1,
    },

    '&:focus': {
      color: AccentColor(),
    },
  },
  tabSelected: {
    color: AccentColor(),
  },
  labelContainer: {
    padding: '6px 20px',
  },
});

class TabbedPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tabIndex: 0,
    };
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if (newProps.tabHeaders && this.state.tabIndex >= newProps.tabHeaders.length) {
      this.setState({
        tabIndex: newProps.tabHeaders.length - 1,
      });
    }
  }

  changePageIndex = value => {
    this.setState({ tabIndex: value });
    this.props.tabIndex && this.props.tabIndex(value);
  };

  render() {
    return (
      <MuiThemeProvider theme={muiThemeNext(AccentColor())}>
        <Fragment>
          <div style={{ backgroundColor: '#efefef' }}>{this._renderTabs(this.state.tabIndex)}</div>
          <SwipeableViews
            axis="x"
            index={this.state.tabIndex}
            onChangeIndex={this.changePageIndex}
            style={{ height: '100%' }}
          >
            {this.props.tabBodies.map((body, index) => {
              return (
                <TabContainer key={`body_${index}`} dir={'ltr'}>
                  {body}
                </TabContainer>
              );
            })}
          </SwipeableViews>
          {this.props.tabFooters[this.state.tabIndex]}
        </Fragment>
      </MuiThemeProvider>
    );
  }

  _renderTabs = tabIndex => {
    if (!this.props.tabHeaders) return;
    const { classes } = this.props;

    const background = this.props.backgroundColor
      ? { backgroundColor: this.props.backgroundColor }
      : {};

    return (
      <Tabs
        value={tabIndex}
        onChange={(_event, value) => this.changePageIndex(value)}
        fullWidth
        centered
        classes={{ root: classes.tabsRoot, indicator: classes.tabsIndicator }}
      >
        {this.props.tabHeaders.map(header => {
          return (
            <Tab
              key={`header_${header}`}
              label={header}
              classes={{
                root: classes.tabRoot,
                selected: classes.tabSelected,
                labelContainer: classes.labelContainer,
              }}
              style={{
                fontSize: '13px',
                textTransform: 'none',
                minHeight: '40px',
                fontFamily: 'Circular-Bold',
                ...background,
              }}
            />
          );
        })}
      </Tabs>
    );
  };
}

export default withStyles(styles)(TabbedPanel);
